import React, { useMemo } from 'react';
import { useRMDispatch } from 'redux/hooks';
import { useIngredientStocks, useSelectedStockRows } from 'redux/hooks/IngredientDetail';
import { updateStockPropertyById } from 'redux/reducers/ingredientDetailReducer';

const StockComments = () => {
  const selectedStockRows = useSelectedStockRows();
  const stocks = useIngredientStocks();
  const dispatch = useRMDispatch();

  const comments = useMemo(() => {
    if (stocks?.length && selectedStockRows.length === 1) {
      return stocks[selectedStockRows[0]]?.comments;
    } else {
      return '';
    }
  }, [selectedStockRows, stocks]);

  const changeHandler = (e) => {
    const stockId = stocks[selectedStockRows[0]]?.id;
    if (stockId) {
      dispatch(
        updateStockPropertyById({ id: stockId, value: e.target.value, key: 'comments' }),
      );
    }
  };

  return (
    <div
      id="stockcomments-main-container"
      className="flex basis-full flex-col max-h-full dashed-border"
    >
      <div id="stockcomments-title" className="basis-1/12 p-2 font-bold">
        Selected Stock Comments
      </div>
      <div id="stockcomments-input-container" className="basis-11/12 flex m-2">
        <textarea
          id="stockcomments-input-comments"
          disabled={selectedStockRows.length !== 1}
          value={comments}
          onChange={changeHandler}
          className="w-100 h-100"
        />
      </div>
    </div>
  );
};
export default StockComments;
